import { mapperRulesNames } from '../config/constants';
import { RuleSchema } from '../types';
import { FullWorkDayBonus } from './FullWorkDayBonus';
import { NoPaidBreaksForNonFullShifts } from './NoPaidBreaksForNonFullShifts';

export const RulesWrapper = (props: RuleSchema) => {
  if (mapperRulesNames.FULL_WORK_DAY_BONUSES === props.name) return <FullWorkDayBonus {...props} />;
  if (mapperRulesNames.NO_PAID_BREAKS_FOR_NON_FULL_SHIFTS === props.name)
    return <NoPaidBreaksForNonFullShifts {...props} />;

  return null;
};
